import { createFlagsScheme, schema } from '@funtech-int/yango-shared';

import { clientConfig } from '@/config/client';

export const remoteConfigScheme = createFlagsScheme({
    header_items: schema.arrayOf(schema.string).optional(),
    legal: schema.arrayOf(schema.create({ id: schema.string, link: schema.string })).optional(),
    support_links: schema.mapOf(schema.string).optional(clientConfig.clientSupportLinks),
    onboarding_config: schema
        .create({ isYasminaInfoBlockEnabled: schema.boolean.optional() })
        .optional(),
});
